import React from "react";
import { useMediaQuery } from 'react-responsive';
import WebBusinessHeader from './Web';
import MobileBusinessHeader from './Mobile';

const BusinessHeader = () => {
    const isDesktop = useMediaQuery({ minWidth: 768 }); // 目前PC和平板的尺寸没有做区分
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <div>
            {isDesktop && <WebBusinessHeader />}
            {isMobile && <MobileBusinessHeader />}
        </div>
    );
};

export default BusinessHeader;